import { useState, useEffect, useRef } from 'react';

import MehrLesenCell from './MehrLesenCell';

import './BestandDetails.css';

import arrowDown from '../svg/Pfeil-nach-unten.svg';
import arrowUp from '../svg/Pfeil-nach-oben.svg';

import { BestandDetailsProps, BeField, ClickableButton } from '../interfaces';

function BestandDetails({ beRow }:BestandDetailsProps) {
  const [details, setDetails] = useState<Array<BeField>>([]);
  const [bePropsCollapsed, setBePropsCollapsed] = useState<boolean>(true);

  const propsBlock = useRef<HTMLDivElement>(null);

  const url = '/webclient/php/be_details.php?be_id=' + beRow.id;

  // const urlRef = useRef<string>(url);

  useEffect(() => {
    fetch(url)
      .then((res) => {
        if (!res.ok) {
          throw new Error('Anfrage fehlgeschlagen');
        }
        return res.json();
      })
      .then((data) => {
        setDetails(data);
      })
      .catch((err) => {
        console.log(err.message);
      });
  }, []);

  function toggleBePropsView() {
    setBePropsCollapsed(!bePropsCollapsed);
  }

  function filterTextLength(text:string):string {
    if (window.innerWidth < 1200 && text.length > 65) {
      return text.slice(0, 65) + '...';
    }
    if (window.innerWidth > 1199 && text.length > 100) {
      return text.slice(0, 100) + '...';
    }
    return text;
  }

  return (
    <div className="bestand-props">
      <h1 className="bestand-props-header h1">{filterTextLength('Bestand: ' + beRow.abk + ' - ' + beRow.name)}</h1>
      <button 
        type="button" 
        className={bePropsCollapsed ? 'read-more-button arrow-down' : 'read-more-button arrow-up'} 
        onClick={toggleBePropsView}
      >
        {bePropsCollapsed ? 'Bestandsinformationen einblenden' : 'Bestandsinformationen ausblenden'}
      </button>
      <ul className={bePropsCollapsed ? 'bestand-props-content display-none' : 'bestand-props-content display-block'}>
        <div className="bestand-props-table-left">
          <li className="">
            <span className="bestand-label">{details[5]?.label}</span>
            <span>{details[5]?.content}</span>
          </li>
          <li className="">
            <span className="bestand-label">{details[6]?.label}</span>
            <span>{details[6]?.content}</span>
          </li>
          <li className="">
            <span className="bestand-label">{details[3]?.label}</span>
            <span>{details[3]?.content}</span>
          </li>
          <li className="">
            <span className="bestand-label">{details[4]?.label}</span>
            <span>{details[4]?.content}</span>
          </li>
        </div>
        <div className="bestand-props-table-middle">
          <li className="">
            <span className="bestand-label">{details[7]?.label}</span>
            <span>{details[7]?.content}</span>
          </li>
          <li className="">
            <span className="bestand-label">{details[8]?.label}</span>
            <span>{details[8]?.content}</span>
          </li>
          <li className="">
            <span className="bestand-label">{details[9]?.label}</span>
            <span>{details[9]?.content}</span>
          </li>
        </div>

        <div className="bestand-props-table-right">
          <li className="">
            <span className="bestand-label">{details[2]?.label}</span>
            <span>
              <MehrLesenCell 
                text={typeof details[2]?.content === 'string' ? details[2]?.content : ''} 
                filterText=""
                tooltipText=""
              />
            </span>
          </li>
        </div>
      </ul>
    </div>
  );
}

export default BestandDetails;

function BestandProp({ label, content }:BeField) {
  return (
    <li className="bestand-prop">
      <p className="bestand-label">{label}</p>
      <p className="bestand-content">{content}</p>
    </li>
  );
}
